import { usePermissions } from "contexts/permission";
import { useQuery } from "@tanstack/react-query";
import { getPermissionsForItem } from "directus/src/operations";

/**
 * Hook to check if a user can edit specific fields on a user profile
 * Admins can edit all fields, users can only edit their own self-editable fields
 */
export function useSelfEditPermission(targetItem, field, collection) {
  const permissions = usePermissions();

  return useQuery({
    queryKey: [
      "self-edit-permission",
      targetItem,
      field,
      permissions.user?.id,
    ],
    queryFn: async () => {
      const result = await getPermissionsForItem(collection, targetItem);

      const hasUpdatePermission = result.update.access;

      const hasPermission = permissions.hasFieldAccess(
        collection,
        "update",
        field,
      );

      if (hasUpdatePermission && hasPermission) {
        return { canEdit: true, reason: "has_permission" };
      }

      if (!permissions.isSelfEditing(targetItem)) {
        return { canEdit: false, reason: "not_self" };
      }

      return { canEdit: false, reason: "no_permission" };
    },
  });
}
